// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2r2Ot","content":"GlobalSearch_content__3Exqb"};